import { useTimeout } from "usehooks-ts";

import CustomCard from "components/CustomCard";
import useSignInSignUp from "components/SignInSignUpModal/useSignInSignUp";
import useAuthentication from "hooks/useAuthentication";

const SignUpPage = () => {
  const { authenticated } = useAuthentication();
  const { toggleModal } = useSignInSignUp();

  useTimeout(() => {
    if (!authenticated) toggleModal("sign-up");
  }, 15000);

  return (
    <>
      <div className="flex items-center justify-end h-[37px]"></div>
      <CustomCard className="mt-[8px] text-center italic text-[18px]">
        <p>
          Get a personalised Feed that is based on your preferences and refined
          with every Insight you read.
        </p>
        <p>
          <span
            onClick={() => toggleModal("sign-up")}
            className="text-smart-teal hover:text-smart-teal cursor-pointer"
          >
            Sign up
          </span>{" "}
          to create your Free Preview Pass.
        </p>
      </CustomCard>
    </>
  );
};

export default SignUpPage;
